import { postAction, getAction } from './manage';

export function queryEmpList(data){
    return new Promise((resolve, reject) => {
        postAction('/prevent/epm/empList', data).then(res=>{
            if(res.success){
                resolve(res.result);
            } else {
                resolve([])
            }
        }).catch(e => {
            resolve([])
        });
    });
}

/**
 * 同步员工数据到中间库
 * @returns {Promise<unknown>}
 */
export function syncEmp(){
  return new Promise((resolve, reject) => {
    getAction('/prevent/epm/sync').then(res=>{
      if(res.success){
        resolve(res.result);
      } else {
        resolve([])
      }
    }).catch(e => {
      resolve([])
    });
  });
}

/**
 * 从中间库拉取核酸数据
 * @returns {Promise<unknown>}
 */
export function pullEmp(){
  return new Promise((resolve, reject) => {
    getAction('/prevent/epm/pull').then(res=>{
      if(res.success){
        resolve(res.result);
      } else {
        resolve([])
      }
    }).catch(e => {
      resolve([])
    });
  });
}